import { gql } from '@apollo/client';

const GET_STUDENT_ASSESSMENT_SCORES = gql`
  query getStudentAssessmentScores($where: StudentAssessmentsWhereInput!) {
    studentAssessments(where: $where) {
      id
      studentId
      assessmentId
      stats {
        score
        pointsScored
        pointsPossible
      }
    }
  }
`;

export default GET_STUDENT_ASSESSMENT_SCORES;
